/* Apply heavy section background art only when the section is within ~1.5 screens (see sm-base.css). */
(() => {
  const els = () => document.querySelectorAll('[data-sm-lazy-bg]:not(.is-bg-in)');
  if (!('IntersectionObserver' in window)) { els().forEach((e) => e.classList.add('is-bg-in')); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-bg-in'); io.unobserve(en.target); } });
  }, { rootMargin: '150% 0px' });
  const run = () => els().forEach((e) => io.observe(e));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('beforeprint', () => els().forEach((e) => e.classList.add('is-bg-in')));
})();
